import {
  useAssetConvertTo3DLink,
  useAssetConvertToVideoLink,
} from "domains/assets/hooks/useAssetLink";
import { useTeamContext } from "domains/teams/contexts/TeamProvider";
import {
  AsideCard,
  AsideList,
  AsideSection,
} from "domains/ui/components/Aside";
import Icon from "domains/ui/components/Icon";
import { GetAssetsByAssetIdApiResponse } from "infra/api/generated/api";

export interface AsideSectionConvertProps {
  asset: GetAssetsByAssetIdApiResponse["asset"] | undefined;
  onAction?: () => void;
}

export default function AsideSectionConvert({
  asset,
  onAction,
}: AsideSectionConvertProps) {
  const { isReader } = useTeamContext();

  const linkConvertTo3D = useAssetConvertTo3DLink(asset);
  const canConvertTo3D = !!linkConvertTo3D;

  const linkConvertToVideo = useAssetConvertToVideoLink(asset);
  const canConvertToVideo = !!linkConvertToVideo;

  const canEdit = (canConvertTo3D || canConvertToVideo) && !isReader;

  if (!asset || !canEdit) {
    return null;
  }

  return (
    <AsideSection id="convert" title="Convert">
      <AsideList>
        {canConvertTo3D && (
          <AsideCard
            size="sm"
            icon={<Icon id="Nav/3D/Outline" h="18px" />}
            title="3D"
            internalLink={linkConvertTo3D}
            data-testid="edit-image-convert-to-3d"
            onClick={onAction}
          />
        )}
        {canConvertToVideo && (
          <AsideCard
            size="sm"
            icon={<Icon id="Nav/Video/Outline" h="18px" />}
            title="Video"
            internalLink={linkConvertToVideo}
            data-testid="edit-image-convert-to-video"
            onClick={onAction}
          />
        )}
      </AsideList>
    </AsideSection>
  );
}
